import React from 'react';
import { ArrowLeftIcon, CheckIcon } from 'lucide-react';
import { DS } from '../ds';
import { AlinovaConstellation, GradientText } from '../Visuals';
import { Label, P } from '../Primitives';
const values = [{
  label: 'Innovación constante en tecnología dental'
}, {
  label: 'Compromiso con la calidad en cada alineador'
}, {
  label: 'Orientación total al profesional de salud'
}, {
  label: 'Confianza y transparencia en cada proceso'
}];
const LAB_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/1d527790-eace-448e-9b2d-43ad970bf7cd.jpg';
const TEAM_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/e8e8723a-ef4f-4ab7-9923-cad6ae453196.jpg';
const CONSULT_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/0148cacf-222d-43b5-b783-2444b36ae706.jpg';
interface AboutSectionProps {
  onBack: () => void;
}
export function AboutSection({
  onBack
}: AboutSectionProps) {
  return <div id="nosotros" style={{
    minHeight: '100vh',
    background: DS.color.ivory,
    paddingTop: '68px'
  }} data-id="element-127" data-mp="1e6v49hod3k4c">
      {/* Hero — fondo claro */}
      <section aria-labelledby="about-title" style={{
      background: `linear-gradient(160deg, #FDFAF5 0%, #F5F0E8 50%, #EEF7F7 100%)`,
      padding: '64px 24px 80px',
      position: 'relative',
      overflow: 'hidden',
      borderBottom: `1px solid ${DS.color.border}`
    }} data-id="element-128" data-mp="19jr7vh5q5rb1">
        {/* Grid CAD sutil */}
        <div aria-hidden="true" style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: 'linear-gradient(rgba(26,95,115,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(26,95,115,0.03) 1px, transparent 1px)',
        backgroundSize: '52px 52px',
        pointerEvents: 'none'
      }} data-id="element-129" data-mp="1sbjzb755b4gn" />

        <AlinovaConstellation width={360} height={360} opacity={0.05} rotation="counter" style={{
        position: 'absolute',
        top: '-80px',
        right: '-60px',
        pointerEvents: 'none'
      }} data-id="element-130" data-mp="2ba616o8hkzlm" />

        <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
      }} data-id="element-131" data-mp="3vs84cg2kb47w">
          {/* Botón volver */}
          <button type="button" onClick={onBack} style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          background: DS.color.mint,
          border: `1.5px solid ${DS.color.aqua}60`,
          borderRadius: DS.radius.pill,
          padding: '8px 18px',
          color: DS.color.tealDeep,
          fontFamily: DS.font.body,
          fontSize: '13px',
          fontWeight: 600,
          cursor: 'pointer',
          marginBottom: '40px',
          transition: `all 0.2s ${DS.ease.smooth}`,
          boxShadow: '0 2px 8px rgba(11,31,36,0.06)'
        }} onMouseEnter={e => {
          e.currentTarget.style.background = DS.color.teal;
          e.currentTarget.style.borderColor = DS.color.teal;
          e.currentTarget.style.color = '#fff';
        }} onMouseLeave={e => {
          e.currentTarget.style.background = DS.color.mint;
          e.currentTarget.style.borderColor = `${DS.color.aqua}60`;
          e.currentTarget.style.color = DS.color.tealDeep;
        }} data-id="element-132" data-mp="3qtdl5d0ondn9">
            <ArrowLeftIcon size={14} aria-hidden="true" data-id="element-133" data-mp="2dubpkzy10v95" />
            Volver al inicio
          </button>

          <Label data-id="element-134" data-mp="nj74nsh2ng6o">Nosotros</Label>
          <h1 id="about-title" style={{
          fontFamily: DS.font.heading,
          fontWeight: 700,
          fontSize: 'clamp(2rem, 5vw, 3.2rem)',
          color: DS.color.ink,
          lineHeight: 1.1,
          letterSpacing: '-0.025em',
          margin: '12px 0 24px'
        }} data-id="element-135" data-mp="nifjlbl3p0un">
            Tecnología dental hecha{' '}
            <GradientText data-id="element-136" data-mp="twbebcsqzqy7">con propósito.</GradientText>
          </h1>
          <P size="lg" align="center" maxWidth="580px" data-id="element-137" data-mp="yw7kniox3ugx">
            Somos el aliado tecnológico para odontólogos y ortodoncistas que
            quieren ofrecer ortodoncia invisible con precisión, respaldo clínico
            y una presentación que diferencia su clínica.
          </P>
        </div>
      </section>

      {/* Contenido principal */}
      <section style={{
      maxWidth: '1100px',
      margin: '0 auto',
      padding: '72px 24px 96px'
    }} data-id="element-138" data-mp="fymsa1my2drk">
        {/* Bloque 1 — quiénes somos + imagen laboratorio */}
        <div className="col-2" style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '56px',
        alignItems: 'center',
        marginBottom: '80px'
      }} data-id="element-139" data-mp="3jngdtgrpvh8r">
          <div data-id="element-140" data-mp="375nfde9blqn4">
            <div style={eyebrowStyle} data-id="element-141" data-mp="37319dj22vj70">¿Por qué Alinova?</div>
            <h2 style={{
            fontFamily: DS.font.heading,
            fontWeight: 700,
            fontSize: 'clamp(1.5rem, 3vw, 2rem)',
            color: DS.color.ink,
            lineHeight: 1.2,
            letterSpacing: '-0.02em',
            marginBottom: '20px'
          }} data-id="element-142" data-mp="324ztf6zy7zzr">
              Fabricamos para que tú te enfoques en lo que más importa.
            </h2>
            <p style={bodyCopyStyle} data-id="element-143" data-mp="2jdgsd5phiw0d">
              En Alinova nos dedicamos al diseño y fabricación de alineadores
              invisibles que combinan tecnología de vanguardia, estética y
              comodidad. Permitimos a los odontólogos ofrecer tratamientos
              efectivos y discretos sin depender de infraestructura técnica propia.
            </p>

            <p style={{
            ...bodyCopyStyle,
            marginTop: '16px',
            fontStyle: 'italic',
            borderLeft: `3px solid ${DS.color.aqua}`,
            paddingLeft: '18px',
            color: DS.color.tealDeep
          }} data-id="element-144" data-mp="1vrd4qb2jgkcn">
              "Precios accesibles, alineadores de máxima calidad y cuidado
              en cada detalle — porque hacer difícil lo fácil no tiene sentido."
            </p>

            <div style={{
            marginTop: '28px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
          }} data-id="element-145" data-mp="2jgp9myqu2695">
              {values.map(v => <div key={v.label} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }} data-id="element-146" data-mp="29pupq1127iqv">
                  <span style={{
                width: '22px',
                height: '22px',
                borderRadius: '50%',
                background: DS.color.mint,
                border: `1px solid ${DS.color.aqua}40`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }} data-id="element-147" data-mp="3299z067bpt87">
                    <CheckIcon size={12} color={DS.color.teal} strokeWidth={3} data-id="element-148" data-mp="7tltpupr9pl1" />
                  </span>
                  <span style={{
                fontFamily: DS.font.body,
                fontSize: '14px',
                color: DS.color.body
              }} data-id="element-149" data-mp="2wc6mlpu9q0d">
                    {v.label}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Imagen 1 — laboratorio dental con impresión 3D */}
          <div style={{
          borderRadius: DS.radius.cardLg,
          overflow: 'hidden',
          boxShadow: '0 24px 80px rgba(11,31,36,0.12)',
          aspectRatio: '4/5',
          position: 'relative',
          background: DS.color.linen
        }} data-id="element-150" data-mp="1nam6ospspbuk">
            <img src={LAB_IMAGE} alt="Laboratorio dental Alinova con tecnología de impresión 3D" style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
            transition: `transform 0.6s ${DS.ease.smooth}`
          }} onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.04)'} onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} data-id="element-151" data-mp="2gcn8olenndfa" />
            <div style={{
            position: 'absolute',
            bottom: '20px',
            left: '20px',
            padding: '10px 16px',
            borderRadius: '12px',
            background: 'rgba(11,31,36,0.72)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            border: '1px solid rgba(75,199,210,0.2)'
          }} data-id="element-152" data-mp="15pzk8buy7sod">
              <div style={{
              fontFamily: DS.font.body,
              fontSize: '11px',
              fontWeight: 700,
              color: DS.color.aquaLight,
              letterSpacing: '0.08em',
              textTransform: 'uppercase'
            }} data-id="element-153" data-mp="ofltjc9anx1b">
                Tecnología de precisión
              </div>
            </div>
          </div>
        </div>

        {/* Divisor */}
        <div style={{
        height: '1px',
        background: `linear-gradient(90deg, transparent, ${DS.color.aqua}40, transparent)`,
        marginBottom: '80px'
      }} data-id="element-154" data-mp="ozx6i8nk175" />

        {/* Bloque 2 — Misión + imagen equipo (orden invertido) */}
        <div className="col-2" style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '56px',
        alignItems: 'center',
        marginBottom: '80px'
      }} data-id="element-155" data-mp="k30f2kvityld">
          {/* Imagen 2 — equipo de especialistas */}
          <div style={{
          borderRadius: DS.radius.cardLg,
          overflow: 'hidden',
          boxShadow: '0 24px 80px rgba(11,31,36,0.12)',
          aspectRatio: '4/5',
          position: 'relative',
          background: DS.color.linen
        }} data-id="element-156" data-mp="o4ln9sx41op8">
            <img src={TEAM_IMAGE} alt="Equipo de especialistas Alinova en clínica dental" style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
            transition: `transform 0.6s ${DS.ease.smooth}`
          }} onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.04)'} onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} data-id="element-157" data-mp="17upc2ejafb8n" />
            <div style={{
            position: 'absolute',
            bottom: '20px',
            left: '20px',
            padding: '10px 16px',
            borderRadius: '12px',
            background: 'rgba(11,31,36,0.72)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            border: '1px solid rgba(75,199,210,0.2)'
          }} data-id="element-158" data-mp="2urf1lfbq6x3v">
              <div style={{
              fontFamily: DS.font.body,
              fontSize: '11px',
              fontWeight: 700,
              color: DS.color.aquaLight,
              letterSpacing: '0.08em',
              textTransform: 'uppercase'
            }} data-id="element-159" data-mp="2btcb0w3j4s3y">
                Equipo Alinova
              </div>
            </div>
          </div>

          {/* Texto misión */}
          <div data-id="element-160" data-mp="3ur7g37o21ldd">
            <div style={eyebrowStyle} data-id="element-161" data-mp="3uqpa3jblbss9">Misión</div>
            <h2 style={{
            fontFamily: DS.font.heading,
            fontWeight: 700,
            fontSize: 'clamp(1.5rem, 3vw, 2rem)',
            color: DS.color.ink,
            lineHeight: 1.2,
            letterSpacing: '-0.02em',
            marginBottom: '20px'
          }} data-id="element-162" data-mp="3urh78yku5ykn">
              Transformar la ortodoncia para profesionales colombianos.
            </h2>
            <p style={bodyCopyStyle} data-id="element-163" data-mp="clvrhc7gn5ss">
              Ofrecemos alineadores de calidad superior adaptados a las
              necesidades de los pacientes y los estándares de los
              profesionales. Herramientas personalizadas, soporte técnico
              y materiales de alta tecnología para tratamientos efectivos,
              cómodos y discretos.
            </p>

            {/* Stats */}
            <div style={{
            marginTop: '32px',
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '16px'
          }} data-id="element-164" data-mp="1hk99bcuc8tuy">
              {[{
              value: '+50',
              label: 'Casos entregados'
            }, {
              value: '24h',
              label: 'Tiempo de respuesta'
            }, {
              value: '100%',
              label: 'Material certificado'
            }, {
              value: 'INVIMA',
              label: 'Certificación vigente'
            }].map(stat => <div key={stat.label} style={{
              padding: '16px 20px',
              borderRadius: '14px',
              background: DS.color.white,
              border: `1px solid ${DS.color.border}`,
              boxShadow: DS.shadow.card
            }} data-id="element-165" data-mp="25b4uvs87astr">
                  <div style={{
                fontFamily: DS.font.heading,
                fontWeight: 700,
                fontSize: '1.6rem',
                color: DS.color.tealDeep,
                marginBottom: '2px'
              }} data-id="element-166" data-mp="3gyhiuz6d3dum">
                    {stat.value}
                  </div>
                  <div style={{
                fontFamily: DS.font.body,
                fontSize: '12px',
                color: DS.color.muted
              }} data-id="element-167" data-mp="3lrkct8f1wpbc">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* Divisor */}
        <div style={{
        height: '1px',
        background: `linear-gradient(90deg, transparent, ${DS.color.aqua}40, transparent)`,
        marginBottom: '80px'
      }} data-id="element-168" data-mp="3205oiz6goh6m" />

        {/* Bloque 3 — Visión + imagen consulta */}
        <div className="col-2" style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '56px',
        alignItems: 'center',
        marginBottom: '80px'
      }} data-id="element-169" data-mp="pr72nq3n9dp5">
          <div data-id="element-170" data-mp="fwf7esxjb2xj">
            <div style={{
            ...eyebrowStyle,
            color: DS.color.kraft
          }} data-id="element-171" data-mp="ksx6bc66o71y">Visión</div>
            <h2 style={{
            fontFamily: DS.font.heading,
            fontWeight: 700,
            fontSize: 'clamp(1.5rem, 3vw, 2rem)',
            color: DS.color.ink,
            lineHeight: 1.2,
            letterSpacing: '-0.02em',
            marginBottom: '20px'
          }} data-id="element-172" data-mp="kv06uq4ypikx">
              Liderar el futuro de la ortodoncia invisible en Colombia.
            </h2>
            <p style={bodyCopyStyle} data-id="element-173" data-mp="1rhc4t69mk8sg">
              Aspiramos a ser la marca de referencia reconocida por innovación
              constante, personalización de cada tratamiento y una experiencia
              que hace accesible, cómoda y estéticamente impecable la
              transformación de cada sonrisa.
            </p>

            {/* Quote */}
            <div style={{
            marginTop: '28px',
            padding: '20px 24px',
            borderRadius: '16px',
            background: DS.color.white,
            border: `1px solid ${DS.color.border}`,
            borderLeft: `4px solid ${DS.color.kraft}`,
            boxShadow: DS.shadow.card
          }} data-id="element-174" data-mp="213euat7oxr4e">
              <p style={{
              fontFamily: DS.font.body,
              fontSize: '14px',
              color: DS.color.body,
              lineHeight: 1.7,
              margin: 0,
              fontStyle: 'italic'
            }} data-id="element-175" data-mp="1idf5m7frie1i">
                "Imaginamos un mundo donde la transformación de una sonrisa
                sea accesible, cómoda y estéticamente impecable, brindando
                a cada persona la confianza para mostrar su mejor versión."
              </p>
            </div>
          </div>

          {/* Imagen 3 — ortodoncista con paciente */}
          <div style={{
          borderRadius: DS.radius.cardLg,
          overflow: 'hidden',
          boxShadow: '0 24px 80px rgba(11,31,36,0.12)',
          aspectRatio: '4/3',
          position: 'relative',
          background: DS.color.linen
        }} data-id="element-176" data-mp="3k45nk1e9hup2">
            <img src={CONSULT_IMAGE} alt="Ortodoncista revisando alineadores invisibles con paciente" style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
            transition: `transform 0.6s ${DS.ease.smooth}`
          }} onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.04)'} onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} data-id="element-177" data-mp="2wdjr77dmdyuw" />
            <div style={{
            position: 'absolute',
            bottom: '20px',
            left: '20px',
            padding: '10px 16px',
            borderRadius: '12px',
            background: 'rgba(11,31,36,0.72)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            border: '1px solid rgba(75,199,210,0.2)'
          }} data-id="element-178" data-mp="122gbo2rlgn3x">
              <div style={{
              fontFamily: DS.font.body,
              fontSize: '11px',
              fontWeight: 700,
              color: DS.color.aquaLight,
              letterSpacing: '0.08em',
              textTransform: 'uppercase'
            }} data-id="element-179" data-mp="1kyg2vbcqzmmg">
                Experiencia clínica
              </div>
            </div>
          </div>
        </div>

        {/* Banner INVIMA — claro y llamativo */}
        <div style={{
        borderRadius: '24px',
        overflow: 'hidden',
        boxShadow: `0 8px 40px rgba(75,199,210,0.14)`,
        border: `2px solid ${DS.color.aqua}50`
      }} data-id="element-180" data-mp="2nddb25ttp4lp">
          {/* Franja animada */}
          <div style={{
          height: '4px',
          background: `linear-gradient(90deg, ${DS.color.teal}, ${DS.color.aqua}, ${DS.color.teal})`,
          backgroundSize: '200% 100%',
          animation: 'shimmerBar 3s linear infinite'
        }} data-id="element-181" data-mp="2icfshs4wi8jo" />

          <div style={{
          padding: '32px 40px',
          background: DS.color.white,
          display: 'flex',
          alignItems: 'center',
          gap: '24px',
          flexWrap: 'wrap'
        }} data-id="element-182" data-mp="1uoxu3dr4sc7q">
            {/* Escudo */}
            <div style={{
            width: '52px',
            height: '52px',
            flexShrink: 0,
            borderRadius: '14px',
            background: `linear-gradient(135deg, ${DS.color.mint}, #E0F5F5)`,
            border: `2px solid ${DS.color.aqua}50`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: `0 4px 16px rgba(75,199,210,0.18)`
          }} data-id="element-183" data-mp="1ql9lqsuodclf">
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none" data-id="element-184" data-mp="28hx8f3v34dtj">
                <path d="M13 2l4.5 2V10c0 4-2.5 6.5-4.5 7.5C11 16.5 8.5 14 8.5 10V4L13 2z" fill={`${DS.color.teal}15`} stroke={DS.color.teal} strokeWidth="1.5" strokeLinejoin="round" data-id="element-185" data-mp="2cj8rsrnd82ta" />
                <path d="M10 10.5l2.5 2.5 4-4" stroke={DS.color.tealDeep} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" data-id="element-186" data-mp="2rfzqszt4ncid" />
              </svg>
            </div>

            <div style={{
            flex: 1,
            minWidth: '200px'
          }} data-id="element-187" data-mp="31kg4bmj4whj0">
              <div style={{
              fontFamily: DS.font.body,
              fontSize: '11px',
              fontWeight: 700,
              color: DS.color.teal,
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              marginBottom: '5px'
            }} data-id="element-188" data-mp="31jy125y2131l">
                Laboratorio certificado · INVIMA
              </div>
              <div style={{
              fontFamily: DS.font.heading,
              fontWeight: 700,
              fontSize: '17px',
              color: DS.color.ink,
              marginBottom: '3px'
            }} data-id="element-189" data-mp="2wl3in5401gi0">
                ADL Importaciones S.A.S
              </div>
              <div style={{
              fontFamily: DS.font.body,
              fontSize: '13px',
              color: DS.color.muted
            }} data-id="element-190" data-mp="6wktt9n7wltw">
                Propietario del establecimiento{' '}
                <span style={{
                color: DS.color.teal,
                fontWeight: 600
              }} data-id="element-191" data-mp="izx7rpnrp8pm">
                  Labtek Soluciones Dentales 3D
                </span>
              </div>
            </div>

            <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '10px 20px',
            borderRadius: DS.radius.pill,
            background: `linear-gradient(135deg, ${DS.color.mint}, #E0F5F5)`,
            border: `1.5px solid ${DS.color.aqua}60`,
            fontFamily: DS.font.body,
            fontSize: '13px',
            fontWeight: 700,
            color: DS.color.tealDeep,
            whiteSpace: 'nowrap',
            boxShadow: `0 4px 12px rgba(75,199,210,0.15)`
          }} data-id="element-192" data-mp="svgxtvfnhd6g">
              <span style={{
              width: '7px',
              height: '7px',
              borderRadius: '50%',
              background: DS.color.teal,
              display: 'block',
              flexShrink: 0,
              animation: 'waPulse 2.5s ease-out infinite'
            }} data-id="element-193" data-mp="36387uh94ac29" />
              Certificación INVIMA vigente
            </div>
          </div>
        </div>

        {/* Keyframe */}
        <style data-id="element-194" data-mp="2iddwy58cyxkn">{`
          @keyframes shimmerBar {
            0%   { background-position: 0% 50%; }
            100% { background-position: 200% 50%; }
          }
        `}</style>
      </section>
    </div>;
}
const eyebrowStyle: React.CSSProperties = {
  fontFamily: DS.font.body,
  fontSize: '11px',
  fontWeight: 700,
  color: DS.color.teal,
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  marginBottom: '14px'
};
const bodyCopyStyle: React.CSSProperties = {
  fontFamily: DS.font.body,
  fontSize: '15px',
  color: DS.color.body,
  lineHeight: 1.8,
  margin: 0
};